const VoucherIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="#4d1010"
    viewBox="0 0 48 48"
    {...props}
  >
    <g id="SVGRepo_iconCarrier">
      <g id="Layer_2" data-name="Layer 2">
        <path
          id="invisible_box"
          fill="none"
          d="M0 0h48v48H0z"
          data-name="invisible box"
        ></path>
        <g id="Layer_7" data-name="Layer 7">
          <path d="M43 7h-5a2 2 0 0 0-1.4.6L34 10.2l-2.6-2.6A2 2 0 0 0 30 7H5a2.9 2.9 0 0 0-3 3v28a2.9 2.9 0 0 0 3 3h25a2 2 0 0 0 1.4-.6l2.6-2.6 2.6 2.6a2 2 0 0 0 1.4.6h5a2.9 2.9 0 0 0 3-3V10a2.9 2.9 0 0 0-3-3m-1 30h-3.2l-3.4-3.4a1.9 1.9 0 0 0-2.8 0L29.2 37H6V11h23.2l3.4 3.4a1.9 1.9 0 0 0 2.8 0l3.4-3.4H42Z"></path>
          <path d="M34 17a2 2 0 0 0-2 2v2a2 2 0 0 0 4 0v-2a2 2 0 0 0-2-2M34 25a2 2 0 0 0-2 2v2a2 2 0 0 0 4 0v-2a2 2 0 0 0-2-2"></path>
          <circle cx="14" cy="20" r="2"></circle>
          <circle cx="22" cy="28" r="2"></circle>
          <path d="m21.6 17.6-10 10a1.9 1.9 0 0 0 0 2.8 1.9 1.9 0 0 0 2.8 0l10-10a2 2 0 0 0-2.8-2.8"></path>
        </g>
      </g>
    </g>
  </svg>
);

export default VoucherIcon;
